var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-12 text-xs text-gray-600 gap-x-4 p-4 items-end"},[_c('div',{staticClass:"col-span-9"},[_vm._v("Description")]),_c('div',{staticClass:"col-span-2 text-right"},[_vm._v("Amount")])])
}]

export { render, staticRenderFns }